import { signal } from '@angular/core';
import { ClubShieldConfig } from '../models/types';

export const DEFAULT_CLUB_SHIELD: ClubShieldConfig = {
  templateId: 'ALA', primaryColor: '#ffffff', secondaryColor: '#ffffff', initials: '', textColor: '',
};
const shields = signal<Record<string, ClubShieldConfig>>({});
const key = (id: string) => `lom_club_shield_${id}`;
function valid(value: any): value is ClubShieldConfig {
  return value && typeof value.templateId === 'string' && /^[A-Z0-9_-]+$/.test(value.templateId)
    && /^#[0-9a-f]{6}$/i.test(value.primaryColor) && /^#[0-9a-f]{6}$/i.test(value.secondaryColor)
    && typeof value.initials === 'string' && /^[A-Z0-9]{0,3}$/.test(value.initials)
    && (value.textColor == null || value.textColor === '' || /^#[0-9a-f]{6}$/i.test(value.textColor));
}

/** Read across league switches and reloads; all readers subscribe to the same signal. */
export function getCachedClubShield(id: string): ClubShieldConfig | null {
  const current = shields()[id];
  if (current) return current;
  try {
    const value = JSON.parse(localStorage.getItem(key(id)) || 'null');
    return valid(value) ? value : null;
  } catch { return null; }
}

/** Call only with successful API responses. Missing fields from older servers do not erase known data. */
export function cacheClubShields(rows: { clubId: string; shield?: ClubShieldConfig | null }[]): void {
  const updates: Record<string, ClubShieldConfig> = {};
  for (const row of rows) {
    if (!row.clubId || row.shield === undefined) continue;
    const value = row.shield === null ? DEFAULT_CLUB_SHIELD : row.shield;
    if (!valid(value)) continue;
    updates[row.clubId] = { ...value };
    try { localStorage.setItem(key(row.clubId), JSON.stringify(value)); } catch { /* Memory cache still works. */ }
  }
  if (Object.keys(updates).length) shields.update(previous => ({ ...previous, ...updates }));
}
